<template>
    <div class="many-select" v-click-outside="() => {this.isOpen = false}">
        <div class="many-select__display" @click="isOpen = !isOpen">
            <div class="many-select__display-text">
                {{ values }}
            </div>

            <div class="many-select__display-arrow">
                <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.70472 4.68313C3.9177 4.8877 4.19891 5 4.50037 5C4.80109 5 5.0838 4.8877 5.29528 4.68313L8.78009 1.23404C9.0733 0.951504 9.0733 0.494439 8.78009 0.211902C8.48763 -0.0706341 8.01294 -0.0706341 7.71972 0.211902L4.50037 3.40564L1.28028 0.211902C0.987064 -0.0706341 0.513123 -0.0706341 0.21991 0.211902C-0.0733033 0.494439 -0.0733033 0.951504 0.21991 1.23404L3.70472 4.68313Z" fill="black"/></svg>
            </div>
        </div>

        <transition name="fade-filter">
            <div v-show="isOpen" class="many-select__content">
                <div v-for="option in options" :key="option.id" class="many-select__item">
                    <input type="checkbox" :name="`${name}[${option.id}]`"
                           :id="`${name}-${option.id}`"
                           v-model="option.checked"
                           :disabled="option.disabled"
                           :checked="isChecked(option)"
                           class="many-select__input">
                    <label v-if="option.objectName"
                           :for="`${name}-${option.id}`"
                           class="many-select__label">{{ option.title }}, {{ option.objectName.toLowerCase() }}
                    </label>
                    <label v-else
                           :for="`${name}-${option.id}`"
                           class="many-select__label">{{ option.title }}, {{ option.objectName.toLowerCase() }}
                    </label>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import Observer from 'common/scripts/observer';

const observer = new Observer();

export default {
    props: ['name', 'options'],

    data: () => {
        return {
            isOpen: false
        };
    },

    computed: {
        values() {
            return Object.values(this.options)
                .filter((option) => {
                    return option.checked;
                })
                .map((option) => {
                    const queue = option.objectName.toLowerCase();

                    return `${option.title}, ${queue}`;
                })
                .join('; ') || 'Все';
        }
    },

    created() {
        this._subscribes();
    },

    directives: {
        ClickOutside
    },

    methods: {
        isChecked(option) {
            return option.checked === true ? 'checked' : null;
        },

        _subscribes() {
            observer.subscribe('resetManySelect', () => {
                return Object.values(this.options)
                    .map((option) => {
                        if (option.checked === true) {
                            option.checked = null;

                            return null;
                        }

                        return null;
                    })
                    .join(' ,') || 'Все';
            });
        }
    }
};
</script>
